import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import editIcon from 'images/icons/invite/edit.svg';
import Tooltip from 'components/ui/Tooltip';
import Modal from './Modal';

export default function EditButton({ affiliateTrainingStep }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        bsStyle="link"
        className="mr10"
        style={{ padding: 0 }}
        onClick={() => setShowModal(true)}
        data-tip="Edit"
      >
        <img src={editIcon} alt="update affiliate training step" />
      </Button>

      <Tooltip />

      <Modal
        affiliateTrainingStep={affiliateTrainingStep}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
}

EditButton.propTypes = {
  affiliateTrainingStep: PropTypes.object.isRequired,
};
